import { Permission, UserInfo } from "./IUserContext";
import { ICacheService } from "./CacheService";
import { Appl } from "../Appl";
import { ProblemDetails, ValidationError } from "./ErrorService";
import { AppPermissions } from "./AppPermissions";

export class UserContextBase {

    public _cache: ICacheService = Appl.Cache;
    public userInfoKey = 'UserInfo';

    public async initAsync(): Promise<void> {
        let sessionStarted = await this._cache.getCookieAsync<boolean>("userSession");
        if (!sessionStarted) {
            console.log('UserContextBase Init Async - Inside');
            await this._cache.removeAllCacheAsync();
            await this._cache.addOrUpdateCookieAsync<boolean>("userSession", true);
            if (!document.referrer.toLowerCase().includes(Appl.Setting.MyScersPortalUrl?.toLowerCase()!)) {
                window.location.reload();
            }
        }
    }

    public get isAuthenticated(): boolean {
        return this.getUser()?.userId !== undefined;
    }

    public async isAuthenticatedAsync(): Promise<boolean> {
        let user = await this.getUserAsync();
        return user !== undefined;
    }

    public get userId(): string | undefined {
        return this.getUser()?.userId;
    }

    public async userIdAsync(): Promise<string | undefined> {
        let user = await this.getUserAsync();
        return user?.userId;
    }

    public get email(): string | undefined {
        return this.getUser()?.email;
    }

    public get displayName(): string | undefined {
        let displayName = '';
        let user = this.getUser();
        if (user) {
            if (user.displayName) {
                displayName = user.displayName;
            } else if (user.email) {
                displayName = user.email;
            }
        }
        return displayName;
    }

    public get photo(): string {
        return this.getUser()?.photo!;
    }

    public get accessToken(): string | undefined {
        let user = this.getUser();
        if (user) {
            return user.accessToken;
        }
        return undefined;
    }

    public get roles(): Array<string> {
        let roles = this.getUser()?.roles;
        if (!roles) {
            roles = [];
        }
        return roles;
    }

    public get permissions(): Array<Permission> {
        let user = this.getUser();
        if (user) {
            if (user.permissions) {
                return user.permissions;
            } else {
                return [];
            }
        }
        return [];
    }

    public hasRole(roleName: string): boolean | undefined {
        return this.roles?.includes(roleName)
    }


    public hasPermission(permissionName: AppPermissions): boolean {
        if (permissionName === AppPermissions.PublicAccess) {
            return true;
        } else if (permissionName === AppPermissions.AuthenticatedUser && this.isAuthenticated) {
            return true;
        }
        if (!this.isAuthenticated) {
            return false;
        }
        // console.log(JSON.stringify(this.permissions));
        let stringToSearch = `"${permissionName}"`;
        let valid = JSON.stringify(this.permissions).indexOf(stringToSearch) > 1;
        return valid;
    }

    public get hasTokenExpired(): boolean {
        let token = this.getUser();
        if (!token) return true;
        const currentTime = Date.now() / 1000; // Convert to seconds
        //return token.exp < currentTime;
        return false;
    }

    public async saveUserAsync(user?: UserInfo): Promise<void> {
        if (user == null) {
            return;
        }
        await this._cache.addOrUpdateAsync(this.userInfoKey, JSON.stringify(user))
    }

    public getUser(): UserInfo {
        const user = this._cache.get<UserInfo>(this.userInfoKey) as UserInfo;
        if (user === null) {
            return {
                userId: undefined, username: undefined, email: undefined,
                roles: new Array<string>,
                permissions: new Array<Permission>,
                displayName: undefined, photo: undefined
            } as UserInfo
        }
        return user;
    }

    public async getUserAsync(): Promise<UserInfo> {
        const user = await this._cache.getAsync<UserInfo>(this.userInfoKey) as UserInfo;
        if (user === null) {
            return {
                userId: undefined, username: undefined, email: undefined,
                roles: new Array<string>,
                permissions: new Array<Permission>,
                displayName: undefined, photo: undefined
            } as UserInfo
        }
        return user;
    }

    public getFetchProblemDetails(error: any): ProblemDetails {
        let pb = new ProblemDetails();
        pb.detail = error.nessage;
        pb.title = 'Network Error'
        let val = new ValidationError();
        val.detail = error.message;
        val.pointer = "";
        pb.errors = [val];
        return pb;
    }
}